<ion-content [fullscreen]="true" class="page-content" color="light">
  <modal-container [breadcrumbsList]="breadcrumbsList" [hideSaveButton]="true">
    <section class="telemetry-shell">
      <div class="telemetry-hero">
        <div class="telemetry-hero__copy">
          <span class="eyebrow">Realtime dashboard</span>
          <h1>{{ deviceLabel || 'Device non disponibile' }}</h1>
        </div>

        <div class="connection-pill" [ngClass]="'connection-pill--' + connectionState">
          <span class="connection-pill__dot"></span>
          <span>{{ connectionLabel }}</span>
        </div>
      </div>

      <div class="telemetry-meta-strip">
        <div class="meta-pill">
          <span class="meta-pill__label">Ultimo update</span>
          <span class="meta-pill__value">{{ formatDateTime(latestTelemetry?.timestamp) }}</span>
        </div>
        <div class="meta-pill">
          <span class="meta-pill__label">Boot time</span>
          <span class="meta-pill__value">{{ formatDateTime(latestMetrics?.boot_time) }}</span>
        </div>
        <div class="meta-pill">
          <span class="meta-pill__label">Source</span>
          <span class="meta-pill__value">{{ latestTelemetry?.source || '--' }}</span>
        </div>
        <div class="meta-pill">
          <span class="meta-pill__label">Sequence</span>
          <span class="meta-pill__value">#{{ latestTelemetry?.sequenceNumber ?? '--' }}</span>
        </div>
      </div>

      @if (hasTelemetryData) {
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--cpu">
            <ion-icon name="pulse-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">CPU attuale</span>
            <span class="stat-card__value">{{ (latestMetrics?.cpu_usage_pct ?? 0) | number:'1.0-1' }}%</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--memory">
            <ion-icon name="hardware-chip-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">RAM usata</span>
            <span class="stat-card__value">{{ formatBytes(latestMetrics?.memory_used_bytes) }}</span>
            <span class="stat-card__hint">su {{ formatBytes(latestMetrics?.memory_total_bytes) }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--disk">
            <ion-icon name="server-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">Disco usato</span>
            <span class="stat-card__value">{{ formatBytes(latestMetrics?.disk_used_bytes) }}</span>
            <span class="stat-card__hint">su {{ formatBytes(latestMetrics?.disk_total_bytes) }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--temperature">
            <ion-icon name="thermometer-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">Temperatura</span>
            <span class="stat-card__value">{{ (latestMetrics?.temperature_celsius ?? 0) | number:'1.0-1' }}&deg;C</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--wifi">
            <ion-icon name="wifi-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">Segnale Wi-Fi</span>
            <span class="stat-card__value">{{ latestMetrics?.wifi?.signal_level_dbm ?? '--' }} dBm</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--uptime">
            <ion-icon name="time-outline"></ion-icon>
          </div>
          <div class="stat-card__content">
            <span class="stat-card__label">Uptime servizio</span>
            <span class="stat-card__value">{{ formatDuration(latestMetrics?.service_uptime) }}</span>
            <span class="stat-card__hint">{{ currentSamplesCount }}/{{ maxSamplesCount }} campioni</span>
          </div>
        </div>
      </div>

      <div class="charts-grid">
        <article class="wita-card border_cpu">
          <div class="card-header">
            <div>
              <span class="header-title">CPU Usage</span>
              <span class="header-subtitle">{{ sampleWindowLabel }}</span>
            </div>
            <span class="header-value">{{ (latestMetrics?.cpu_usage_pct ?? 0) | number:'1.0-1' }}%</span>
          </div>

          <div class="chart-body">
            <div echarts [options]="cpuChartOptions" [initOpts]="{ renderer: 'canvas' }" [autoResize]="true"
              class="echarts-chart"></div>
          </div>
        </article>

        <article class="wita-card border_usage">
          <div class="card-header">
            <div>
              <span class="header-title">RAM e Disco</span>
              <span class="header-subtitle">{{ sampleWindowLabel }}</span>
            </div>
            <span class="header-value">Utilizzo %</span>
          </div>

          <div class="chart-body">
            <div echarts [options]="usageChartOptions" [initOpts]="{ renderer: 'canvas' }" [autoResize]="true"
              class="echarts-chart"></div>
          </div>
        </article>

        <article class="wita-card border_temperature">
          <div class="card-header">
            <div>
              <span class="header-title">Temperatura</span>
              <span class="header-subtitle">{{ sampleWindowLabel }}</span>
            </div>
            <span class="header-value">{{ (latestMetrics?.temperature_celsius ?? 0) | number:'1.0-1' }}&deg;C</span>
          </div>

          <div class="chart-body">
            <div echarts [options]="temperatureChartOptions" [initOpts]="{ renderer: 'canvas' }" [autoResize]="true"
              class="echarts-chart"></div>
          </div>
        </article>

        <article class="wita-card border_connectivity">
          <div class="card-header">
            <div>
              <span class="header-title">Connettivita e Load</span>
              <span class="header-subtitle">{{ sampleWindowLabel }}</span>
            </div>
            <span class="header-value">Wi-Fi / Load 1m</span>
          </div>

          <div class="chart-body">
            <div echarts [options]="connectivityChartOptions" [initOpts]="{ renderer: 'canvas' }" [autoResize]="true"
              class="echarts-chart"></div>
          </div>
        </article>
      </div>
      } @else {
      <div class="empty-realtime-state">
        @if (connectionState === 'connecting') {
        <ion-spinner name="crescent"></ion-spinner>
        } @else {
        <div class="empty-realtime-state__icon">
          <ion-icon name="analytics-outline"></ion-icon>
        </div>
        }

        <h2>{{ connectionLabel }}</h2>
        <p>{{ connectionMessage }}</p>

        @if (lastError) {
        <span class="empty-realtime-state__error">{{ lastError }}</span>
        }
      </div>
      }
    </section>
  </modal-container>
</ion-content>